import axios from 'axios'

let getFoldersController;

export default {
  getAvailablePermissions () {
    return axios.get(`/banner/layout_folder/available-permissions`)
  },
  getFolderPermissionsData (folderId) {
    return axios.get(`/banner/layout_folders/${folderId}/permissions-data`)
  },
  getFolders (params = {}) {
    if (getFoldersController) {
      getFoldersController.abort();
    }
    getFoldersController = new AbortController();
    return axios.get('/banner/layout_folder_list', { params, signal: getFoldersController.signal })
  },
  getBreadcrumbs (folderId) {
    return axios.get('/banner/layout_folder_breadcrumbs', { params: {folderId} });
  },
  syncFolderPermissions(folderId, users, groups) {
    return axios.post(`/banner/layout_folders/sync-folder-permissions`, {
      folder_id: folderId,
      users,
      groups
    });
  },
  createFolder(parent_id, name) {
    return axios.post('/banner/layout_folder_create', { parent_id, name });
  },
  checkFolderName (name) {
    return axios.get('/banner/layout_folder_check_name', { params: { name } })
  },
  deleteFolder(folderId) {
    return axios.delete('/banner/layout_folder_delete', { data: { folderId } });
  },
  editFolder(folderId, folderName) {
    return axios.put('/banner/layout_folder_edit', { folderId, folderName });
  },
  linkToFolder(folderId, layoutIds, customerIds, folderName) {
    return axios.post('/banner/layout_link_to_folder', { folderId, layoutIds, customerIds, folderName });
  },
  moveLayoutsToFolder(folderId, layoutIds) {
    return axios.post('/banner/layout_move_to_folder', { folderId, layoutIds });
  },
  moveFoldersToFolder(folderId, folderIdsToMove) {
    return axios.post('/banner/folders_move_to_folder', { folderId, folderIdsToMove });
  },
  copyToFolders(folders, layoutIds, customerIds) {
    return axios.post('/banner/layout_copy_to_folders', { folders, layoutIds, customerIds });
  },
  getFolderContent(folderId) {
    return axios.get('/banner/layout_folder_content', {
      params: {
        folderId
      }
    });
  },
  deleteFolderLayout(folderId, layoutId) {
    return axios.delete('/banner/layout_folder_delete_layout', { data: { folderId, layoutId } });
  },
  deleteFolderLayouts(folderId, layoutIds) {
    return axios.delete('/banner/layout_folder_delete_layouts', { data: { folderId, layoutIds } });
  },
  archiveFolderItem(layout) {
    const { customer_id, id } = layout
    
    return axios.patch(`/banner/${customer_id}/group/${id}/archive_layout_from_folder`, { data: { layout } });
  },
  archiveLayout(customer_id, layout_id) {
    return axios.patch(`/banner/${customer_id}/group/${layout_id}/archive_layout_from_folder`);
  },
  getFolder (folderId) {
    return axios.get(`/banner/layout_folders/${folderId}`);
  },
  previewFolderProofs(folderId) {
    return axios.post(`/banner/layout_folders/${folderId}/proofs/preview`);
  },
  createFolderProofs(folderId, updateExisting) {
    return axios.post(`/banner/layout_folders/${folderId}/proofs`, {
      update_existing: updateExisting,
    });
  },
  applyFolderActionToFolders(type, targetFolderId, folderIds, customerIds, folderName) {
    return axios.post('/banner/folders_action', {
      type,
      targetFolderId,
      folderIds,
      customerIds,
      folderName,
    });
  },
}
